module.exports = __webpack_public_path__ + "6429cdacd9b61953c4b82be6a07adead.png";